/* eslint-disable */
// src/services/personService.js
import axios from "services/axiosConfig";
import { attachLocalsToClients } from "utils/clientLocals";

const API_URL = "/api/person";

async function getClientsWithLocals(path) {
  const clientsResponse = await axios.get(path);
  const clients = Array.isArray(clientsResponse.data) ? clientsResponse.data : [];
  if (clients.length === 0) return clients;

  try {
    const active = await axios.get("/api/local");
    const inactive = await axios.get("/api/local/inactive");
    if (!Array.isArray(active.data) || !Array.isArray(inactive.data)) {
      throw new Error("La respuesta de locales no es una lista.");
    }
    return attachLocalsToClients(clients, [...active.data, ...inactive.data]);
  } catch (error) {
    console.error("Error al obtener los locales de los clientes:", error);
    return clients.map((person) => ({
      ...person,
      Locals: Array.isArray(person.Locals) ? person.Locals : null,
    }));
  }
}

class PersonService {
  // Crear persona (isActive true)
  static async createPerson(person) {
    try {
      const { data } = await axios.post(API_URL, person);
      return data;
    } catch (error) {
      console.error("Error al crear la persona:", error);
      throw error;
    }
  }

  // obtener personas (isActive true)
  static async getActivePersons() {
    try {
      const { data } = await axios.get(API_URL);
      return data;
    } catch (error) {
      console.error("Error al obtener las personas activas:", error);
      return [];
    }
  }

// Obtener TODAS las personas tipo Cliente (activas e inactivas)
  static async getAllClients() { 
    try { 
      const { data } = await axios.get(`${API_URL}/clients`); 
      return data; 
    } catch (error) { 
      console.error("Error al obtener todos los clientes:", error); 
      return []; 
    } 
  } 

// Obtener personas tipo client isActive true
static async getActiveClients() {
  try {
    return await getClientsWithLocals(`${API_URL}/clients/active`);
  } catch (error) {
    console.error("Error al obtener los clientes activos:", error);
    return [];
  }
}

  // obtener personas (isActive false)
  static async getInactivePersons() {
    try {
      const { data } = await axios.get(`${API_URL}/inactive`);
      return data;
    } catch (error) {
      console.error("Error al obtener las personas inactivas:", error);
      return [];
    }
  }

  // Obtener clientes inactivos
static async getInactiveClients() {
  try {
    return await getClientsWithLocals(`${API_URL}/clients/inactive`);
  } catch (error) {
    console.error("Error al obtener los clientes inactivos:", error);
    return [];
  }
}

  // obtener persona por ID con isActive true
  static async getPersonById(id) {
    try {
      const { data } = await axios.get(`${API_URL}/${id}`);
      return data;
    } catch (error) {
      console.error("Error al obtener la persona por ID:", error);
      return null;
    }
  }

  // Actualizar una persona, no modifica el campo isActive
  static async updatePerson(id, person) {
    try {
      const { data } = await axios.put(`${API_URL}/${id}`, person);
      return data;
    } catch (error) {
      console.error("Error al editar la persona:", error);
      throw error;
    }
  }

  // Eliminar Soft-delete (isActive true → false)
static async deletePerson(id) {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return { ok: response.status === 204 };
  } catch (error) {
    if (error.response?.status === 409 &&
        error.response?.data?.code === 'PERSON_HAS_ACTIVE_LOCALS') {
      return {
        ok: false,
        code: 'PERSON_HAS_ACTIVE_LOCALS',
        message: error.response.data.error,
      };
    }

    console.error("Error al desactivar la persona:", error);
    return { ok: false };
  }
}

  // Reactivar (isActive false → true)
  static async reactivatePerson(id) {
    try {
      const response = await axios.patch(`${API_URL}/${id}/reactivate`);
      return response.status === 204;
    } catch (error) {
      console.error("Error al reactivar la persona:", error);
      return false;
    }
  }
}

export default PersonService;
